import { useActorUser } from "@-/dev.improve.haniverse.lib.user";

/**
 * Source-of-truth for which frequency corpus the rank UI reads from. Traditional script
 * uses the Taiwan Ministry of Education BIAU corpus; everything else falls back to
 * SUBTLEX-CH (mainland subtitle frequencies).
 */
type CardFrequencyRankInput =
  | {
      biau1Rank?: number | null | undefined;
      morphemeType: "grapheme";
      subtlexChrRank?: number | null | undefined;
    }
  | {
      biau2Rank?: number | null | undefined;
      morphemeType: "word";
      subtlexWfRank?: number | null | undefined;
    };

export function getCardFrequencyRank(
  card: CardFrequencyRankInput,
  script: "simplified" | "traditional",
): number | null {
  if (card.morphemeType === "word") {
    if (script === "traditional") {
      return card.biau2Rank ?? null;
    }
    return card.subtlexWfRank ?? null;
  }
  if (script === "traditional") {
    return card.biau1Rank ?? null;
  }
  return card.subtlexChrRank ?? null;
}

export function useCardFrequencyRank(card: CardFrequencyRankInput): number | null {
  const { hanziScript } = useActorUser();
  return getCardFrequencyRank(card, hanziScript);
}
